// 跳转微信小程序中转页
<template>
  <div class="GroupBulkShelvesContent">
    <GroupBulkShelvesContent ref="GroupBulkShelvesContentRef" @visibleChange="visibleChange"></GroupBulkShelvesContent>
  </div>
</template>

<script>
import GroupBulkShelvesContent from '@/components/prod/center/dialogs/GroupBulkShelvesDialog/GroupBulkShelvesContent.vue';
import { getDetailByOceanItemIds } from '@/api/base/index.js';

export default {
  components: {
    GroupBulkShelvesContent,
  },
  data() {
    return {};
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false);
      this.$nextTick(() => {
            window.parent.postMessage({ data: { isMounted: true }, eventName: 'mounted' },'*'); 
       });
  },

  methods: {
    receiveMessage(event) {
      const { data = {}, eventName } = event.data;
      if (eventName == 'open') {
            let { list } = data.publishParams || {};
            let rows = [];
            const params = {
                supplyItemInfoList: list || []
            };
            getDetailByOceanItemIds(params).then((res) => {
                rows = res.data || [];
                if (rows.length == 0) {
                    this.$message.error('不存在分销数据，请仔细检查！');
                    return;
                }
                this.$refs.GroupBulkShelvesContentRef.method_open(rows);
            });
        
      } else if ('closeDialog') {
      }
    },
    visibleChange(visible) {
        // if (!visible) {
        //     window.parent.postMessage({ data: {  }, eventName: 'close' }, '*');
        //     return;
        // }
    },
  },
};
</script>

<style lang='scss' scoped>
    .GroupBulkShelvesContent{
        width: 800px;
        margin: 20px auto;
    }
</style>
